const de = {
  'appManuals.downloadHelpText':
    'Die Dateien können über Internetbrowser oder PDF-Reader-Software angezeigt werden.',
  'appManuals.systemRequirements':
    'Hardware Requirements (Recommended): Intel® Core™ i3 or higher CPU, 4 GB or more memory, 100 MB or more free storage space for PDF saving.',
  'appManuals.medicalsoftware.helptext':
    'Die Medizinsoftware kann je nach Land unterschiedlich sein.',
  '이미 등록된 라이선스가 있습니다.': 'Eine Lizenz ist bereits registriert.',
  '갱신 가능한 기존 라이선스를 찾을 수 없습니다.':
    'Es wurde keine bestehende Lizenz gefunden, die erneuert werden kann.',
  '발급 가능한 잔여 수량이 없습니다.': 'Keine verbleibende Menge zur Ausstellung verfügbar.',
  // --- eIFU portal UI labels & language names (issue #16) ---
  'show all manuals': 'Alle Handbücher anzeigen',
  'This site complies with the General Data Protection Regulation (EU 2016/679).': 'Diese Website entspricht der Datenschutz-Grundverordnung (EU 2016/679).',
  'This site meets the requirements of the General Data Protection Regulation (EU 2016/679).': 'Diese Website erfüllt die Anforderungen der Datenschutz-Grundverordnung (EU 2016/679).',
  'the content of this site is protected against unauthorized modification.': 'Die Inhalte dieser Website sind vor unbefugter Änderung geschützt.',
  'Previous versions of the User Manual are available for viewing and downloading via search.': 'Frühere Versionen des Benutzerhandbuchs können über die Suche eingesehen und heruntergeladen werden.',
  'Checking the latest documents.': 'Die neuesten Dokumente werden überprüft.',
  'There are no manuals to display.': 'Es sind keine Handbücher zum Anzeigen vorhanden.',
  'Manuals': 'Handbücher',
  'Product Name': 'Produktname',
  'Language': 'Sprache',
  'Document Name': 'Dokumentname',
  'Product': 'Produkt',
  'Revision': 'Revision',
  'Document': 'Dokument',
  'Published': 'Veröffentlicht',
  'English': 'Englisch',
  'Korean': 'Koreanisch',
  'Japanese': 'Japanisch',
  'German': 'Deutsch',
  'Russian': 'Russisch',
  'Chinese (Simplified)': 'Chinesisch (vereinfacht)',
  'Chinese (Traditional)': 'Chinesisch (traditionell)',
  'Country': 'Land',
  'All countries': 'Alle Länder',
  'Search': 'Suchen',
  'No results': 'Keine Ergebnisse',
  'eifuPortalIntro':
    'Durchsuchen und laden Sie die elektronische Gebrauchsanweisung (eIFU) der RAY-Medizingerätesoftware herunter.',
  "criticalNotice.badge": "Wichtiger Hinweis",
  "criticalNotice.close": "Schließen",
};

export default de;
